<template>
  <div>
    <vs-input class="w-full mb-10" v-model="dataLocal.rate" :label-placeholder="'获得1积分需要投注' + dataLocal.rate + '元'" />
    <vs-input class="w-full" v-model="dataLocal.val" :label-placeholder="'1积分可兑换' + dataLocal.val + '元'" />
  </div>
</template>

<script>

export default {
  props: {
    data: {
      type: String,
      default: '{}'
    }
  },
  data() {
    return {
      dataLocal: {}
    }
  },
  methods: {
    getParam() {
      return JSON.stringify(this.dataLocal)
    }
  },
  mounted() {
    this.dataLocal = JSON.parse(this.data)
  }
}
</script>
